module.exports = __webpack_public_path__ + "img/wangrunyu.0641845f.jpg";